export const MAIN_HEADER_HEIGHT = 64;
export const MAIN_HEADER_HEIGHT_SMALL = 56;
export const STICKY_HEADER_HEIGHT = 56;
